import React from "react";
import {
    Row,
    Col,
    Form,
    FormGroup,
    FormInput,
    Card,
    CardBody,
    FormCheckbox
} from "shards-react";
import { Link } from "react-router-dom";
import PasswordStrengthBar from "react-password-strength-bar";
import withLoading from "../../hocs/withLoading/withLoading";
import { ResponsiblePrimaryButton } from "../buttons/ResponsibleAmeButton";
import PropTypes from "prop-types";

import "./password-form.css";

const PasswordForm = props => {
    const {
        isTemporaryPassword,
        screen,
        showIcon,
        informations,
        configFirstInput,
        configSecondtInput,
        configExtraInput,
        configButton,
        hasLink,
        showBackLink
    } = props;
    const {
        formSubmit,
        onchange,
        onChangeCheckbox,
        onChangeScore
    } = props.actions;
    PasswordForm.propTypes = {
        screen: PropTypes.string,
        isTemporaryPassword: PropTypes.bool,
        actions: PropTypes.object,
        informations: PropTypes.object,
        showIcon: PropTypes.bool,
        configFirstInput: PropTypes.object,
        configSecondtInput: PropTypes.object,
        configExtraInput: PropTypes.object,
        configButton: PropTypes.object,
        hasLink: PropTypes.bool,
        showBackLink: PropTypes.bool
    };

    const showStrengthBar =
        window.location.pathname.includes("/redefine_password/") ||
        window.location.pathname.includes("/settings");

    const showExtraInput =
        window.location.pathname === "/reset_password" ||
        window.location.pathname === "/manager/reset_password" ||
        window.location.pathname === "/settings/reset-password" ||
        window.location.pathname === "/manager/settings/reset-password";

    return (
        <Card>
            <CardBody>
                {showIcon && (
                    <React.Fragment>
                        <Row>
                            <Col sm="12" className="form-auth--box">
                                <img
                                    className="user-avatar rounded-circle form-auth--width-image"
                                    src={informations.src}
                                    alt="User Avatar"
                                />
                            </Col>
                        </Row>
                        &nbsp;
                    </React.Fragment>
                )}
                &nbsp;
                <Form
                    onSubmit={e => formSubmit(e)}
                    autoComplete="off"
                    style={{ marginBottom: "10px" }}
                >
                    {showExtraInput && (
                        <FormGroup>
                            <label htmlFor={configExtraInput.name}>
                                {configExtraInput.label}
                            </label>
                            <FormInput
                                required
                                autoComplete={"off"}
                                type={configExtraInput.type}
                                placeholder={configExtraInput.label}
                                name={configExtraInput.name}
                                value={configExtraInput.value}
                                valid={configExtraInput.valid}
                                onChange={e => onchange(e)}
                            />
                        </FormGroup>
                    )}

                    <FormGroup>
                        <label htmlFor={configFirstInput.name}>
                            {configFirstInput.label}
                        </label>
                        <FormInput
                            required
                            type={configFirstInput.type}
                            placeholder={configFirstInput.label}
                            name={configFirstInput.name}
                            value={configFirstInput.value}
                            valid={configFirstInput.valid}
                            onChange={e => onchange(e)}
                        />
                        <div className="form-auth--password-strength-container">
                            {showStrengthBar && (
                                <PasswordStrengthBar
                                    password={configFirstInput.value}
                                    scoreWords={[
                                        "muito fraca",
                                        "fraca",
                                        "média",
                                        "boa",
                                        "forte"
                                    ]}
                                    shortScoreWord={"muito fraca"}
                                    onChangeScore={score =>
                                        onChangeScore(score)
                                    }
                                    className={"form-auth--strength-bar-width"}
                                />
                            )}
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label htmlFor={configSecondtInput.name}>
                            {configSecondtInput.label}
                        </label>
                        <FormInput
                            required
                            type={configSecondtInput.type}
                            placeholder={configSecondtInput.label}
                            name={configSecondtInput.name}
                            value={configSecondtInput.value}
                            valid={configSecondtInput.valid}
                            onChange={e => onchange(e)}
                        />
                    </FormGroup>
                    {screen === "createUserPassword" && (
                        <FormGroup>
                            <FormCheckbox
                                checked={isTemporaryPassword}
                                onChange={e => onChangeCheckbox(e)}
                            >
                                O usuário deve criar uma nova senha no próximo
                                login.
                            </FormCheckbox>
                        </FormGroup>
                    )}
                    <ResponsiblePrimaryButton
                        className={"cypress--confirm-button"}
                        block
                    >
                        {configButton.label}
                    </ResponsiblePrimaryButton>
                </Form>
                {hasLink && (
                    <>
                        <Link
                            to={{
                                pathname: "/accounts/password/reset/"
                            }}
                        >
                            Esqueceu sua senha?
                        </Link>
                    </>
                )}
                {showBackLink && (
                    <Link
                        style={{ display: "block", textAlign: "center" }}
                        to={{
                            pathname: "/"
                        }}
                    >
                        Voltar ao login
                    </Link>
                )}
            </CardBody>
        </Card>
    );
};

const WrappedComponent = withLoading(PasswordForm);

export default WrappedComponent;
